// extracted by mini-css-extract-plugin
export var actions = "_19-0";
export var actionsContainer = "_19-7";
export var border = "_19-1";
export var childFullHeight = "_19-e";
export var collapse = "_19-2";
export var content = "_19-9";
export var contentChild = "_19-d";
export var fullscreen = "_19-b";
export var hasLeftRadius = "_19-j";
export var headerContainer = "_19-3";
export var headerRow = "_19-5";
export var hidePadding = "_19-a";
export var navCollapsedGap = "_19-k";
export var noScrollX = "_19-l";
export var noScrollY = "_19-m";
export var noTopPadding = "_19-h";
export var optOutTopPadding = "_19-c";
export var pageMain = "_19-i";
export var pageOuter = "_19-f";
export var pagePadding = "_19-8";
export var profile = "_19-n";
export var profileContainer = "_19-o";
export var profileImage = "_19-p";
export var profileMain = "_19-q";
export var profileSubtitle = "_19-s";
export var profileTitle = "_19-r";
export var showLeftPadding = "_19-g";
export var tabsPortalSlot = "_19-6";
export var tabsWrapper = "_19-4";
export var title = "_19-t";